module.exports = __webpack_public_path__ + "assets/img/DigitalPictogram_YOUTUBE.92cf713b.svg";